import React from 'react';

function DiscussionSection() {
  return (
    <section className="py-20 bg-ink-50/60 border-t border-ink-100">
      <div className="max-w-5xl mx-auto px-6">
        <p className="section-eyebrow mb-3">06 &middot; Wrap-up</p>
        <h2 className="section-title">Discussion, Limitation & Conclusion</h2>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          <div className="card p-6">
            <div className="text-xs font-semibold uppercase tracking-widest text-brand-600">
              Discussion
            </div>
            <h3 className="mt-2 font-serif font-semibold text-ink-900">
              Beyond &ldquo;Superficial&rdquo;
            </h3>
            <div className="mt-3 text-sm text-ink-600 leading-relaxed space-y-3">
              <p>
                While <strong>SAH</strong> provides valuable insight into
                adversarial scenarios like jailbreaks, this work does not
                propose a specific solution. If these issues are eventually
                resolved within our framework, the term &ldquo;Superficial&rdquo;
                may no longer be necessary.
              </p>
              <p>
                Recent work{' '}
                <a
                  href="https://arxiv.org/abs/2406.05946"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-600 hover:underline"
                >
                  [Qi et al., 2024]
                </a>{' '}
                supports this view. Still, advanced adversarial attacks may
                require a multi-layered approach beyond the model itself.
              </p>
            </div>
          </div>

          <div className="card p-6">
            <div className="text-xs font-semibold uppercase tracking-widest text-accent-600">
              Limitation
            </div>
            <h3 className="mt-2 font-serif font-semibold text-ink-900">
              Scope of Alignment Methods
            </h3>
            <p className="mt-3 text-sm text-ink-600 leading-relaxed">
              In reallocating redundant units, we evaluated only the impact of{' '}
              <strong>Supervised Fine-Tuning (SFT)</strong>. Due to resource
              constraints, this study did not explore{' '}
              <strong>PPO</strong> or <strong>DPO</strong>. Future work could
              extend to these methods for broader generalization.
            </p>
          </div>

          <div className="card p-6">
            <div className="text-xs font-semibold uppercase tracking-widest text-emerald-600">
              Conclusion
            </div>
            <h3 className="mt-2 font-serif font-semibold text-ink-900">
              Safety Alignment Should Not Be Complicated
            </h3>
            <p className="mt-3 text-sm text-ink-600 leading-relaxed">
              We distinguish safety alignment from general alignment in LLMs
              and address three critical questions &mdash; about effect,
              brittleness, and alignment tax &mdash; demonstrating that safety
              alignment can be a straightforward and efficient process.
            </p>
          </div>
        </div>

        <div className="mt-12 max-w-3xl mx-auto">
          <div className="card p-6 md:p-8">
            <div className="text-center text-xs font-semibold uppercase tracking-widest text-ink-500">
              Three questions, three answers
            </div>
            <ul className="mt-4 grid md:grid-cols-3 gap-4 text-sm">
              {[
                'How does safety alignment affect model behavior?',
                'Why are safety mechanisms brittle?',
                'How can the safety alignment tax be mitigated?',
              ].map((q, i) => (
                <li
                  key={q}
                  className="rounded-xl bg-ink-50 p-4 border border-ink-100"
                >
                  <div className="text-[10px] font-bold text-brand-600 mb-1">
                    Q0{i + 1}
                  </div>
                  <div className="text-ink-700 leading-snug italic font-serif">
                    {q}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DiscussionSection;
